/* Loyalty dashboard — hidratálás az App Proxyból.
   A Liquid már kirajzolta a metafieldekből mentett állapotot; ez felülírja az
   ÉLŐ adattal és bekapcsolja az interaktív gombokat.
   Ha a proxy nem elérhető (app még nincs telepítve), a Liquid-érték marad
   és a gombok kikapcsolva maradnak. Semmi nem törik el.

   ⛔ A SZINT-KÁRTYA BLOKK KIVEZETVE (2026-07-24, C-modell): a szint/jelvény-
   rendszer törölve, a /tiers végpont és a widget MK_UI kártya-gyára megszűnt. */
(function () {
  var root = document.querySelector('[data-lty]');
  if (!root || root.dataset.loggedIn !== '1') return;

  var BASE = '/apps/loyalty';
  var $ = function (s) { return root.querySelector(s); };
  var state = null;

  function toast(msg) {
    if (!msg) return;
    var t = document.createElement('div');
    t.className = 'lty-toast';
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 3600);
  }

  function api(path, opts) {
    return fetch(BASE + path, Object.assign({
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin'
    }, opts)).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; })
        .then(function (b) { throw new Error(b.error || ('HTTP ' + r.status)); });
      return r.json();
    });
  }

  function offline() {
    var n = $('[data-lty-offline]');
    if (n) n.hidden = false;
  }

  /* ---------- renderelés ---------- */

  function num(sel, v) { var n = $(sel); if (n) n.textContent = v; }

  function render(s) {
    state = s;
    num('[data-lty-balance]', s.balance);
    num('[data-lty-value]', s.value_huf);

    var code = $('[data-lty-refcode]');
    if (code) code.textContent = s.referral_code;

    renderHist(s);
  }

  function renderHist(s) {
    var el = $('[data-lty-hist]');
    if (!el) return;
    var T = window.dsT || {};
    var LABEL = {
      purchase: T.ev_purchase || 'Vásárlás', signup: T.ev_signup || 'Belépés',
      article: T.ev_article || 'Cikk elolvasva', quiz: T.ev_quiz || 'Kvíz',
      redeem: T.ev_redeem || 'Beváltás', refund: T.ev_refund || 'Visszatérítés',
      referral_giver: T.ev_referral_giver || 'Ajánlás', referral_new: T.ev_referral_new || 'Ajánlóval érkeztél',
      sub_cycle: T.ev_sub_cycle || 'Előfizetés-ciklus', milestone: T.ev_milestone || 'Csomag-mérföldkő',
      purchase_milestone: T.ev_purchase_milestone || 'Rendelés-mérföldkő',
      /* történeti sorok a kivezetett rendszerből — a múltat nem írjuk át */
      sub_milestone: T.ev_sub_milestone || 'Ciklus-mérföldkő', achievement: T.ev_achievement || 'Jelvény-bónusz'
    };
    el.innerHTML = '';
    s.history.forEach(function (h) {
      var tr = document.createElement('tr');
      var td1 = document.createElement('td');
      td1.textContent = LABEL[h.kind] || h.kind;
      var td2 = document.createElement('td');
      td2.textContent = (h.created_at || '').slice(0, 10);
      td2.className = 'lty-dim';
      var td3 = document.createElement('td');
      td3.textContent = (h.points > 0 ? '+' : '') + h.points;
      tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3);
      el.appendChild(tr);
    });
  }

  /* ---------- akciók ---------- */

  function post(path, body) {
    return api(path, { method: 'POST', body: JSON.stringify(body || {}) });
  }

  function wireCopy() {
    var b = $('[data-lty-copy]');
    if (!b) return;
    b.disabled = false;
    b.addEventListener('click', function () {
      var code = state && state.referral_code;
      if (!code) return;
      /* a /discount/ link a kódot a kasszáig viszi (natív Shopify-út) */
      var url = location.origin + '/discount/' + code + '?redirect=/';
      var T2 = window.dsT || {};
      navigator.clipboard.writeText(url)
        .then(function () { toast((T2.copied || 'Kimásolva: ') + url); })
        .catch(function () { toast((T2.your_code || 'A kódod: ') + code); });
    });
  }

  /* ⛔ MVP-VÁGÁS (2026-07-24): a kvíz-UI (loadQuizzes/openQuiz) kivéve —
     az ötlet a vault „Loyalty ötlet-parkoló" jegyzetében. A /quiz végpontok
     a magban maradtak, a UI nem hívja. */

  /* ---------- indulás ---------- */
  api('/me').then(function (s) {
    render(s);
    wireCopy();
  }).catch(function () {
    offline();
  });
})();
